import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  template: `
    <footer [class]="footerClasses" [attr.role]="'contentinfo'">
      <div [class]="containerClasses">
        @if (showCopyright()) {
          <div class="text-center text-sm text-gray-500 dark:text-gray-400">
            {{ copyright() }}
          </div>
        }
        <div class="mt-4">
          <ng-content></ng-content>
        </div>
      </div>
    </footer>
  `,
  styles: []
})
export class FooterComponent {
  copyright = input<string>('© 2024 All rights reserved.');
  showCopyright = input<boolean>(true);
  variant = input<'default' | 'minimal' | 'elevated'>('default');

  get footerClasses(): string {
    const classes = [
      'w-full',
      'bg-white',
      'dark:bg-gray-800',
      'border-t',
      'border-gray-200',
      'dark:border-gray-700',
      'transition-colors',
      'duration-200'
    ];

    if (this.variant() === 'elevated') {
      classes.push('shadow-lg');
    } else if (this.variant() === 'minimal') {
      classes.push('border-0');
    }

    return classes.join(' ');
  }

  get containerClasses(): string {
    return 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6';
  }
}

